import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../ui/command';
import { Check, ChevronsUpDown } from 'lucide-react';

export default function StaffCombobox({ staff, value, onChange, placeholder = 'Seleziona dipendente', noneLabel, testId }) {
  const [open, setOpen] = useState(false);
  const label = (s) => `${s.display_name || `${s.first_name} ${s.last_name}`}${s.store_name ? ` — ${s.store_name}` : ''}`;
  const sel = staff.find(s => s.staff_id === value);
  const display = sel ? label(sel) : (noneLabel && value === '' ? noneLabel : placeholder);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open}
                className={`w-full justify-between rounded-none font-normal mt-1 px-3 ${sel ? 'text-slate-900' : 'text-slate-500'}`}
                data-testid={testId}>
          <span className="truncate">{display}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0 rounded-none" align="start">
        <Command>
          <CommandInput placeholder="Cerca nome…" data-testid={testId ? `${testId}-search` : undefined} />
          <CommandList className="max-h-56">
            <CommandEmpty>Nessun risultato</CommandEmpty>
            <CommandGroup>
              {noneLabel && (
                <CommandItem value={noneLabel} onSelect={() => { onChange(''); setOpen(false); }}
                             data-testid={testId ? `${testId}-opt-none` : undefined}>
                  <Check className={`mr-2 h-4 w-4 ${value === '' ? 'opacity-100' : 'opacity-0'}`} />
                  {noneLabel}
                </CommandItem>
              )}
              {staff.map(s => (
                <CommandItem key={s.staff_id} value={label(s)}
                             onSelect={() => { onChange(s.staff_id); setOpen(false); }}
                             data-testid={testId ? `${testId}-opt-${s.staff_id}` : undefined}>
                  <Check className={`mr-2 h-4 w-4 ${value === s.staff_id ? 'opacity-100' : 'opacity-0'}`} />
                  {label(s)}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
